import UnauthBox from './UnauthBox'

export default UnauthBox



// WEBPACK FOOTER //
// ./src/components/UnauthBox/index.js